export default __webpack_public_path__ + "static/r230-large-0c882dbb1f39f6d5875f23c911208dad.png";